import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { SnackbarProvider } from "notistack";
import { GlobalProvider } from "./services/context/AuthContext";
import { FlightSearchProvider } from "./services/context/FlightSearchContext";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <SnackbarProvider
      maxSnack={3}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <GlobalProvider>
        <FlightSearchProvider>
          <App />
        </FlightSearchProvider>
      </GlobalProvider>
    </SnackbarProvider>
  </BrowserRouter>
);

reportWebVitals();
